import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="overflow-hidden border-t border-white/10 bg-[#090B0E] pt-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-center">
        <Logo />
        <div className="flex flex-wrap gap-6 font-mono text-xs uppercase tracking-[0.2em] text-slate-300">
          {["services", "roofing", "projects", "about", "contact"].map((l) => (
            <a key={l} href={`#${l}`} data-testid={`footer-link-${l}`} className="nav-link hover:text-white">{l}</a>
          ))}
        </div>
      </div>
      <p className="mt-16 select-none font-display text-[18vw] font-black uppercase leading-[0.8] tracking-tight text-white/[0.06] lg:text-[13rem]">Bennett</p>
      <div className="flex flex-col justify-between gap-3 border-t border-white/10 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 sm:flex-row">
        <span>© {new Date().getFullYear()} Bennett Custom Builders</span>
        <span>NM License GB98 · Commercial/Residential · Serving all of Northern NM</span>
      </div>
    </div>
  </footer>
);
